export default __webpack_public_path__ + "static/media/data.237ee352.csv";